






























import { Component, Vue, Prop } from 'vue-property-decorator';
import _ from 'lodash-es';
import constants from '@/utils/constants';
function unique(arr, val): any {
  const res = new Map();
  return arr.filter(item => !res.has(item[val]) && res.set(item[val], 1));
}
@Component({})
export default class BillDetail extends Vue {
  @Prop() item!: any;
  @Prop() showSelectTable!: boolean;
  @Prop(Function) hideSelectTable!: Function;
  @Prop() billListFilter!: any;
  $swal: any;
  outletTables: Array<any> = [];
  loading: boolean = true;
  mounted() {
    this.$store
      .dispatch('GetStoreTables', this.item.outlet_code)
      .then(res => {
        this.loading = false;
        this.outletTables = unique(res.data, 'number');
      })
      .catch(err => {
        console.log(err);
      });
  }
  selectTableHandle(item) {
    if (this.item.table_no === item.number) {
      return this.$swal(
        constants.FAILED_MESSAGE,
        'Target table number and current table number match',
        constants.STATUS_ERROR
      );
    }
    this.$swal({
      title: constants.ARE_YOU_SURE,
      content: {
        element: 'p',
        attributes: {
          innerHTML: `Do you want to change the table number from <b style="color:red">${
            this.item.table_no
          }</b> to <b style="color:red">${item.number}</b>?`
        }
      },
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(isOK => {
      if (isOK) {
        this.$store
          .dispatch('SetNewTable', {
            billingNo: this.item.billing_no,
            tableNo: item.number
          })
          .then(res => {
            if (res.data.message === constants.STATUS_OK_UPPER) {
              document.body.classList.remove('noScroll');
              this.$swal(
                constants.COMPLETED_MESSAGE,
                '',
                constants.STATUS_SUCCESS
              );
              this.$store.dispatch('GetAllBillList', this.billListFilter);
            } else {
              this.$swal(
                constants.FAILED_MESSAGE,
                res.invalidMessage,
                constants.STATUS_ERROR
              );
            }
          });
      }
    });
  }
}
